module.exports = __webpack_public_path__ + "img/lookbook_15_left.93785a8b.png";